import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const POLICY_SLUGS = ["cancellation", "house-rules", "payment", "privacy", "terms"];

export default function PolicyPage() {
  const { slug } = useParams();
  const { trField } = useI18n();
  const [policy, setPolicy] = useState(null);
  const [all, setAll] = useState([]);

  useEffect(() => { api.get("/policies").then((r) => setAll(r.data)); }, []);
  useEffect(() => { api.get(`/policies/${slug}`).then((r) => setPolicy(r.data)).catch(() => setPolicy(null)); }, [slug]);

  return (
    <SiteLayout>
      {policy && <Seo title={`${trField(policy, "title")} · Berdhill Rooms`} description={trField(policy, "content").slice(0, 160)} />}
      <div className="max-w-5xl mx-auto px-4 md:px-8 lg:px-12 py-16 grid lg:grid-cols-4 gap-12">
        <aside className="lg:col-span-1">
          <div className="text-xs tracking-[0.2em] uppercase text-brand-muted mb-4">Policies</div>
          <nav className="space-y-2">
            {POLICY_SLUGS.map((s) => {
              const p = all.find((x) => x.slug === s);
              return (
                <Link
                  key={s}
                  to={`/policies/${s}`}
                  data-testid={`policy-link-${s}`}
                  className={`block text-sm py-1.5 ${s === slug ? "text-brand-primary font-medium" : "text-brand-muted hover:text-brand-text"}`}
                >
                  {p ? trField(p, "title") : s.replace("-", " ")}
                </Link>
              );
            })}
          </nav>
        </aside>
        <article className="lg:col-span-3" data-testid="policy-article">
          {policy ? (
            <>
              <h1 className="font-display text-4xl md:text-5xl">{trField(policy, "title")}</h1>
              <div className="mt-8 prose prose-lg text-brand-text/85 leading-relaxed whitespace-pre-line">
                {trField(policy, "content")}
              </div>
            </>
          ) : (
            <div className="text-brand-muted">Loading…</div>
          )}
        </article>
      </div>
    </SiteLayout>
  );
}
